export type AdminCountKey = 'pendingMessages' | 'pendingRequests';

export interface NavItem {
  to: string;
  label: string;
  icon: string;
  /** Which adminStats count to surface as a badge on this item, if any. */
  countKey?: AdminCountKey;
}

export interface NavGroup {
  label: string;
  items: readonly NavItem[];
}

// Admin navigation, grouped by area. The sidebar renders these groups; pending
// counts ride on the items they belong to (see Sidebar + StatsHeader).
export const NAV_GROUPS: readonly NavGroup[] = [
  {
    label: 'Comunicação',
    items: [
      { to: '/messages', label: 'Mensagens', icon: 'mail', countKey: 'pendingMessages' },
      { to: '/requests', label: 'Pedidos', icon: 'inbox', countKey: 'pendingRequests' },
      { to: '/whistleblow-reports', label: 'Denúncias', icon: 'gavel' },
    ],
  },
  {
    label: 'Conteúdo',
    items: [
      { to: '/news', label: 'Notícias', icon: 'campaign' },
      { to: '/events', label: 'Eventos', icon: 'event' },
      { to: '/galleries', label: 'Galerias', icon: 'photo_library' },
      { to: '/documents', label: 'Documentos', icon: 'description' },
      { to: '/images', label: 'Imagens', icon: 'image' },
    ],
  },
  {
    label: 'Gestão',
    items: [
      { to: '/onboarding', label: 'Configuração', icon: 'settings' },
      { to: '/accounts', label: 'Contas', icon: 'manage_accounts' },
      { to: '/profile', label: 'O meu perfil', icon: 'account_circle' },
    ],
  },
] as const;

// Flat list retained for lookups / any consumer that needs every item.
export const NAV_ITEMS: readonly NavItem[] = NAV_GROUPS.flatMap((g) => g.items);

const isItemActive = (url: string, to: string) => url === to || url.startsWith(to + '/');

// Resolve the "group · label" context breadcrumb for the current URL.
export function activeCrumb(url: string): { group: string; label: string } | null {
  for (const group of NAV_GROUPS) {
    for (const item of group.items) {
      if (isItemActive(url, item.to)) return { group: group.label, label: item.label };
    }
  }
  return null;
}
